import MaintenanceIndexVue from "@/views/maintenance/MaintenanceIndex.vue";

const maintenance = [
  {
    path: "/maintenance",
    name: "maintenance",
    component: MaintenanceIndexVue,
    meta: {
      layout: "default",
      rrole: ["superadmin","backoffice","receptionist","supervisor","maintenance"],
      public: false,
    },
  },
];

export default maintenance;
